import React from 'react'
import './TestActivity.css'
import { bounceInLeft, fadeIn } from 'react-animations'
import styled, { keyframes } from 'styled-components';

export const TestCompletion = () => {
  const a1 = keyframes`${bounceInLeft}`;
  const AnimateContent = styled.div`animation: 2s ${a1};`;

  const a2 = keyframes`${fadeIn}`;
  const AnimateBrand = styled.div`animation: 2s ${a2};`;

  return (
    <div className="completed">
      <AnimateBrand>
          <img className="brand-image" title="InspireOne" src="images/Logo.png"/>
        </AnimateBrand>
      <div className="inner-content">
        <AnimateContent>
          <h1>Assessment Completed</h1>
          <p className="lead">Thank you</p>
        </AnimateContent>
    </div>
    </div>
  )
}
